module.exports = __webpack_public_path__ + "img/modal-close-mustard.42605a29.svg";